import organization_user_list from './user-list';
import organization_user_add from './user-add';
import organization_user_edit from './user-edit';
import organization_user_detail from './user-detail';

export default {
    organization_user_list,
    organization_user_add,
    organization_user_edit,
    organization_user_detail,
};
